import React from 'react'
import { Button } from '@mui/material'
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'

/**
 * Matches EduOKWeb BackButton — yellow pill, aligned to the right of content-header.
 */
const BackButton = ({ onClick, label = 'Back', sx }) => {
  const handleClick = (event) => {
    event.preventDefault()
    if (onClick) {
      onClick(event)
    } else {
      window.history.back()
    }
  }

  return (
    <Button
      type="button"
      size="small"
      className="page-back-button"
      startIcon={<ArrowBackIcon sx={{ fontSize: '0.875rem !important' }} />}
      onClick={handleClick}
      sx={{
        ml: 'auto',
        mt: 0,
        minHeight: 28,
        height: 28,
        lineHeight: 1,
        backgroundColor: '#fff8e1',
        border: '1px solid #ffe082',
        color: '#5c4a00',
        fontSize: '12px',
        fontWeight: 600,
        borderRadius: '6px',
        textTransform: 'none',
        boxShadow: 'none',
        px: 1,
        py: 0.25,
        flexShrink: 0,
        '& .MuiButton-startIcon': {
          marginRight: 0.5,
          marginLeft: 0,
        },
        '&:hover': {
          backgroundColor: '#ffecb3',
          borderColor: '#ffd54f',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
        ...sx,
      }}
    >
      {label}
    </Button>
  )
}

export default BackButton
